import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import axios from "axios";
import { baseUrl, redirectUrl } from "../helper/urls.js";
import {
  Modal,
  Typography,
  Box,
  Avatar,
  IconButton,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import HelpSupportData from "../pages/Admin/Help&Support/HelpSupportData.js";
import Swal from "sweetalert2";
import { toast } from "react-toastify";
import { keyframes } from "@emotion/react";
import DreamdorBanner from "./DreamdorBanner.jsx";
import HowItWorksButton from "./HowItWorksButton.jsx";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { logout } from "../redux/slices/authSlice.js";
// import ThemeToggleButton from "../helper/ThemeToggleButton";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 1200,
  height: 600,
  maxHeight: "80vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  borderRadius: "8px",
  boxShadow: 24,
  p: 4,
};

// const HelpSupportModal = ({ show, onHide }) => {
//   return (
//     <Modal show={show} onHide={onHide} centered>
//       <Modal.Header closeButton>
//         <Modal.Title>Help & Support</Modal.Title>
//       </Modal.Header>
//       <Modal.Body>
//         <Accordion defaultActiveKey="0">
//           {HelpSupportData.map((item, index) => (
//             <Accordion.Item eventKey={index.toString()} key={index}>
//               <Accordion.Header>{item.question}</Accordion.Header>
//               <Accordion.Body>{item.answer}</Accordion.Body>
//             </Accordion.Item>
//           ))}
//         </Accordion>
//       </Modal.Body>
//       <Modal.Footer>
//         <Button variant="secondary" onClick={onHide}>
//           Close
//         </Button>
//       </Modal.Footer>
//     </Modal>
//   );
// };

const HelpSupportModal = ({ open, handleClose }) => {
  return (
    <Modal open={open} onClose={handleClose}>
      {/* <Box sx={style}>
        <Typography variant="h6" mb={2}>
          Help & Support
        </Typography>
        {HelpSupportData.map((item, index) => (
          <Accordion key={index}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography fontWeight="bold">{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Box> */}
      <HelpSupportModalDetails isOpen={open} onClose={handleClose} />
    </Modal>
  );
};
function HelpSupportModalDetails({ isOpen, onClose }) {
  // State to manage the active tab
  const [activeTab, setActiveTab] = useState("Tutorials");

  // If the modal is not open, don't render anything
  if (!isOpen) return null;

  // URLs for embedded content
  const youtubePlaylistUrl =
    "https://www.youtube.com/embed/videoseries?list=PLStZlz6edVrOtR7EpRLZZeDePe2JUA0wy";
  const pdfUrl = "https://app.dreamdor.com/Full%20Comprehensive%20Plan.pdf"; // Sample PDF
  // Using an online viewer for PPT as direct embedding is not natively supported by browsers for live viewing
  const pptUrl =
    "https://view.officeapps.live.com/op/embed.aspx?src=http://app.dreamdor.com/dreamdor_ppt.pptx"; // Sample PPT via Office Online Viewer

  return (
    // Modal Overlay
    <div
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(17, 24, 39, 0.75)", // gray-900 with 75% opacity
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50,
        padding: "16px",
      }}
    >
      {/* Modal Content Area */}
      <div
        style={{
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow:
            "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)", // shadow-2xl
          width: "100%",
          maxWidth: "1024px", // max-w-4xl
          height: "90vh",
          display: "flex",
          flexDirection: "column", // Default to column for small screens
          "@media (min-width: 768px)": {
            // Apply row direction for medium screens and up (md in Tailwind)
            flexDirection: "row",
          },
          overflow: "hidden",
          position: "relative", // For absolute positioning of close button
        }}
      >
        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            position: "absolute",
            top: "16px",
            right: "16px",
            color: "#4b5563", // gray-600
            fontSize: "32px",
            fontWeight: "bold",
            zIndex: 10,
            padding: "8px",
            borderRadius: "9999px", // rounded-full
            backgroundColor: "rgba(255, 255, 255, 0.7)", // bg-white bg-opacity-70
            border: "none",
            cursor: "pointer",
            transition: "background-color 0.2s ease, color 0.2s ease",
            outline: "none",
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 1)"; // hover:bg-opacity-100
            e.currentTarget.style.color = "#111827"; // hover:text-gray-900
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.7)";
            e.currentTarget.style.color = "#4b5563";
          }}
          aria-label="Close modal"
        >
          &times;
        </button>
        <div className="row">
          <div
            style={{
              width: "30%", // Full width on small screens
              flexShrink: 0, // Prevent shrinking on small screens
              backgroundColor: "#f9fafb", // gray-50
              borderRight: "none", // No right border on small screens
              borderBottom: "1px solid #e5e7eb", // Bottom border on small screens
              padding: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "8px", // space-y-2
              overflowY: "auto",
              "@media (min-width: 768px)": {
                // Styles for medium screens and up
                width: "256px", // w-64 for larger screens
                borderRight: "1px solid #e5e7eb", // border-r border-gray-200
                borderBottom: "none",
                // No bottom border on larger screens
              },
            }}
          >
            <h4
              style={{
                fontSize: "12px",
                fontWeight: "bold",
                color: "#1f2937",
                marginBottom: "16px",
                paddingBottom: "8px",
                borderBottom: "1px solid #e5e7eb",
              }}
            >
              Help & Support
            </h4>
            {["Tutorials", "Slide Deck"].map((tab) => (
              <button
                key={tab}
                onClick={() => setActiveTab(tab)}
                style={{
                  width: "100%",
                  textAlign: "left",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  transition:
                    "background-color 0.2s ease, color 0.2s ease, box-shadow 0.2s ease",
                  border: "none",
                  cursor: "pointer",
                  outline: "none",
                  backgroundColor:
                    activeTab === tab ? "#124178" : "transparent", // bg-blue-600 or transparent
                  color: activeTab === tab ? "white" : "#124178", // text-white or gray-700
                  boxShadow:
                    activeTab === tab ? "0 4px 6px rgba(0, 0, 0, 0.1)" : "none", // shadow-md
                }}
                onMouseOver={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = "#e5e7eb"; // hover:bg-gray-200
                  }
                }}
                onMouseOut={(e) => {
                  if (activeTab !== tab) {
                    e.currentTarget.style.backgroundColor = "transparent";
                  }
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          {/* Right Content Area */}
          <div
            style={{
              flex: 1,
              padding: "24px",
              backgroundColor: "white",
              overflowY: "auto",
            }}
          >
            {activeTab === "Tutorials" && (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "18px",
                    fontWeight: "semibold",
                    color: "#1f2937",
                    marginBottom: "16px",
                  }}
                >
                  Tutorials
                </h4>
                <p style={{ color: "#4b5563", marginBottom: "24px" }}>
                  Learn how to use our features with these helpful video
                  tutorials.
                </p>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    flexGrow: 1,
                    paddingBottom: "56.25%",
                    height: 0,
                  }}
                >
                  {/* Responsive YouTube Embed */}
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                    src={youtubePlaylistUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}

            {/* {activeTab === 'Full Comprehensive Plan' && (
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
              <h4 style={{ fontSize: '18px', fontWeight: 'semibold', color: '#1f2937', marginBottom: '16px' }}>Full Comprehensive Plan</h4>
              <p style={{ color: '#4b5563', marginBottom: '24px' }}>Dive deep into our comprehensive plan.</p>
              <div style={{ position: 'relative', width: '100%', flexGrow: 1, paddingBottom: '120%', height: 0 }}>
              
                <iframe
                  style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}
                  src={pdfUrl}
                  title="Full Comprehensive Plan PDF"
                  frameBorder="0"
                ></iframe>
              </div>
            </div>
          )} */}

            {activeTab === "Slide Deck" && (
              <div
                style={{
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <h4
                  style={{
                    fontSize: "18px",
                    fontWeight: "semibold",
                    color: "#1f2937",
                    marginBottom: "16px",
                  }}
                >
                  Slide Deck
                </h4>
                <p style={{ color: "#4b5563", marginBottom: "24px" }}>
                  Review our slide deck.
                </p>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    flexGrow: 1,
                    paddingBottom: "75%",
                    height: 0,
                  }}
                >
                  {/* Responsive PPT Embed via Office Online Viewer */}
                  <iframe
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      borderRadius: "8px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    }}
                    src={pptUrl}
                    title="Slide Deck Presentation"
                    frameBorder="0"
                    allowFullScreen
                  ></iframe>
                </div>
              </div>
            )}
          </div>
        </div>

        {/* Left Sidebar - Tabs */}
      </div>
    </div>
  );
}

// const HelpSupportModal = ({ open, handleClose, helpAndSupportData }) => {
//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={style}>
//         <Typography variant="h6" mb={2}>
//           Help & Support
//         </Typography>
//         {helpAndSupportData?.map((item, index) => (
//           <Accordion key={index}>
//             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//               <Typography fontWeight="bold">{item.question}</Typography>
//             </AccordionSummary>
//             <AccordionDetails>
//               <Typography>{item.answer}</Typography>
//             </AccordionDetails>
//           </Accordion>
//         ))}
//       </Box>
//     </Modal>
//   );
// };

const MasterLayout = ({ children }) => {
  const {
    token,
    name,
    role,
    email,
    status,
    profile,
    interestedIn,
    profileImage,
  } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [sidebarActive, seSidebarActive] = useState(false);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation(); // Hook to get the current route
  const navigate = useNavigate();
  const [policyLoading, setPolicyLoading] = useState(false);
  const [selectedPolicy, setSelectedPolicy] = useState("");
  const [modalTitle, setModalTitle] = useState("");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest(".dropdown");

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains("open");

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove("open");
        const submenu = dropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = "0px"; // Collapse submenu
        }
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add("open");
        const submenu = clickedDropdown.querySelector(".sidebar-submenu");
        if (submenu) {
          submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
        }
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll(
      ".sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link"
    );

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener("click", handleDropdownClick);
    });

    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll(".sidebar-menu .dropdown");
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll(".sidebar-submenu li a");
        submenuLinks.forEach((link) => {
          if (
            link.getAttribute("href") === location.pathname ||
            link.getAttribute("to") === location.pathname
          ) {
            dropdown.classList.add("open");
            const submenu = dropdown.querySelector(".sidebar-submenu");
            if (submenu) {
              submenu.style.maxHeight = `${submenu.scrollHeight}px`; // Expand submenu
            }
          }
        });
      });
    };

    // Open the submenu that contains the active route
    openActiveDropdown();

    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener("click", handleDropdownClick);
      });
    };
  }, [location.pathname]);

  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const callLogoutAPI = async () => {
    try {
      const url = `${baseUrl}/api/users/logout`;
      const response = await axios.get(url);

      if (response.data.message === "Logout Successfully") {
        // Clear sessionStorage
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("user");
        sessionStorage.removeItem("name");
        sessionStorage.removeItem("email");
        sessionStorage.removeItem("profileImage");

        // Update Redux state
        dispatch(logout());

        // Redirect based on role
        window.location.href = "https://dreamdor.com";
      }
    } catch (error) {
      console.error("Logout error:", error);

      // Clear sessionStorage on error
      sessionStorage.clear();
      dispatch(logout());
      window.location.href = "https://dreamdor.com";
    }
  };

  const [helpAndSupportData, sethelpAndSupportData] = useState([]);
  const HelpandSupportApi = async (endPoint) => {
    try {
      const response = await axios.get(`${baseUrl}/api/faq/user/${endPoint}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      sethelpAndSupportData(response.data.data || []);
      console.log("response: ", response);
    } catch (error) {
      console.error("Error fetching help and support data:", error);
      toast.error("Failed to fetch help and support data");
    }
  };
  /////////////////////////////////////////////////////////////////////     Book your 30 mins free Counseling Now

  const [openReq, setOpenReq] = useState(false);
  const handleOpenReqModal = () => setOpenReq(true);
  const handleCloseReqModal = () => setOpenReq(false);

  const [timeValue, setTimeValue] = useState(null);
  const [errors, setErrors] = useState({ time: false, slots: false });
  const [loading, setLoading] = useState(false); // fix camelCase

  const createBookingRequest = async () => {
    setLoading(true);
    const startHourStr = timeValue?.split("-")[0];
    const localTime = new Date();

    if (startHourStr) {
      const hourMatch = startHourStr.match(/(\d+)(AM|PM)/);
      if (hourMatch) {
        let hour = parseInt(hourMatch[1]);
        const period = hourMatch[2];

        if (period === "PM" && hour !== 12) hour += 12;
        if (period === "AM" && hour === 12) hour = 0;

        localTime.setHours(hour, 0, 0, 0);
      }
    }
    const utcTime = localTime.toISOString();

    try {
      const response = await axios.post(
        `${baseUrl}/api/booking_req/create`,
        {
          counselorId: 17,
          call_time: timeValue,
          time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          utcTime: utcTime,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      console.log(response);
      if (response.data.success === true) {
        setOpenReq(false);
        handleApiSuccess(response);
      }
    } catch (error) {
      console.error(
        "Booking request failed:",
        error.response?.data || error.message
      );
      toast.error(
        error.response?.data?.message || "Failed to create booking request"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleApiSuccess = (response) => {
    Swal.fire({
      // text: response?.data?.message || "Role updated successfully",
      text: "Request created successfully",

      icon: "success",
      timer: 4000,
      showConfirmButton: true, // optional: allow manual dismissal
      allowOutsideClick: true,
      allowEscapeKey: true,
    }).finally(() => {
      setTimeValue(null);
      // navigate("/student-requested-slot-list");
    });
  };

  const handleSubmit = () => {
    const newErrors = {
      time: !timeValue,
      // slots: !slotsValue,
    };
    setErrors(newErrors);
    // if (!newErrors.time && !newErrors.slots) {
    if (!newErrors.time) {
      createBookingRequest();
    }
  };

  const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

  // Policies

  const handleOpenPolicy = async (fieldName, title) => {
    setModalTitle(title);
    setShowModal(true);
    setPolicyLoading(true);
    setSelectedPolicy("");

    try {
      const response = await axios.get(`${baseUrl}/api/policy/allPolicy`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });

      const policy = response.data?.data?.[fieldName];
      if (policy) {
        setSelectedPolicy(policy);
      } else {
        toast.warn("Policy content not available.");
      }
    } catch (error) {
      console.error("Error fetching policy:", error);
      toast.error("Failed to fetch policy.");
    } finally {
      setPolicyLoading(false);
    }
  };

  const helpAndSupport = () => {
    navigate("/help-and-support");
  };
  const counselorHelpAndSupport = () => {
    navigate("/counselor-help-and-support");
  };

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside
        className={
          sidebarActive
            ? "sidebar active "
            : mobileMenu
            ? "sidebar sidebar-open"
            : "sidebar"
        }
      >
        <button
          onClick={mobileMenuControl}
          type="button"
          className="sidebar-close-btn"
        >
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="#" className="sidebar-logo">
            <img
              // src="assets/images/logo.png"
              src="https://app.dreamdor.com/assets/images/logo.png"
              alt="site logo"
              className="light-logo"
            />
            <img
              src="https://app.dreamdor.com/assets/images/logo-light.png"
              alt="site logo"
              className="dark-logo"
            />
            <img
              src="https://app.dreamdor.com/assets/images/logo-icon.png"
              alt="site logo"
              className="logo-icon"
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            {/* ////////////////////// ADMIN //////////////////////////////////// */}

            {role === "admin" ? (
              <>
                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon icon="ph:user" className="menu-icon" />
                    <span>Counselors</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    {/* <li style={{margin:"2px"}}>
                      <NavLink
                        to="/add-counselor"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Add Counselor
                      </NavLink>
                    </li> */}
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/all-counselors"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        All Counselors
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/pending-counselor"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                        Pending Counselors
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/approved-counselor"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                        Approved Counselors
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/unapproved-counselor"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-info-main w-auto" />{" "}
                        Rejected Counselors
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/all-students"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="flowbite:users-group-outline"
                      className="menu-icon"
                    />
                    <span>Student</span>
                  </NavLink>
                </li>
                {/* <li style={{margin:"2px"}} className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="flowbite:users-group-outline"
                      className="menu-icon"
                    />
                    <span>Students</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{margin:"2px"}}>
                      <NavLink
                        to="/add-student"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Add Student
                      </NavLink>
                    </li>
                    <li style={{margin:"2px"}}>
                      <NavLink
                        to="/all-students"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        All Students
                      </NavLink>
                    </li>
                  </ul>
                </li> */}
                {/* <li style={{margin:"2px"}}>
                  <NavLink
                    to="/request"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ph:money-wavy" className="menu-icon" />
                    <span>Request</span>
                  </NavLink>
                </li> */}
                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="material-symbols:manage-accounts-outline"
                      className="menu-icon"
                    />
                    <span>Manage Request</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/create-request"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                        Create Request
                      </NavLink>
                    </li>
                    {/* <li style={{margin:"2px"}}>
                      <NavLink
                        to="/bookings"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Create Booking
                      </NavLink>
                    </li>
                    <li style={{margin:"2px"}}>
                      <NavLink
                        to="/all-booking"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Booking List
                      </NavLink>
                    </li> */}
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/request"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Action
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        // to="/student-pending-booking-list"
                        to="/admin-book-slot-for-student"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-success-main w-auto" />
                        <span> Paid </span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/rescheduled-booking-by-admin"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Rescheduled Approval
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/scheduled-booking-by-admin"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Scheduled Slots
                      </NavLink>
                    </li>

                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/completed-booking-by-admin"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Completed Slots
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/canceled-booking-by-admin"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Cancelled
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/webinar"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="material-symbols:web-stories-outline"
                      className="menu-icon"
                    />
                    <span>Webinar Student List</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/invoice"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="material-symbols:receipt-long-outline"
                      className="menu-icon"
                    />
                    <span>Invoice</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="material-symbols:payments-outline"
                      className="menu-icon"
                    />
                    <span>Payouts</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/payments"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:payments-outline"
                          className="menu-icon"
                        />
                        <span>Action</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/payout-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:payments-outline"
                          className="menu-icon"
                        />
                        <span>Payout List</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="material-symbols:settings-alert-outline"
                      className="menu-icon"
                    />
                    <span>CMS</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/sidebar-content-by-admin"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:view-sidebar-outline"
                          className="menu-icon"
                        />
                        <span>Sidebar Content</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/add-blog"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:table-rows-narrow-outline"
                          className="menu-icon"
                        />
                        <span>Add Blog</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/create-faqs"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:medical-mask-outline"
                          className="menu-icon"
                        />
                        <span>Create Faqs</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/create-policy"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:policy-outline"
                          className="menu-icon"
                        />
                        <span>Policy</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/how-to-work"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:home-work-outline"
                          className="menu-icon"
                        />
                        <span>How to work</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/counselor-carousel"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:amp-stories-outline"
                          className="menu-icon"
                        />
                        <span>Counselor Carousel</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/create-package"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:hand-package-outline"
                          className="menu-icon"
                        />
                        <span>Package Details</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/create-resources"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <Icon
                          icon="material-symbols:hand-package-outline"
                          className="menu-icon"
                        />
                        <span>Create Resources</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>
                {/* <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/reports"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ph:chart-pie-slice" className="menu-icon" />
                    <span>Reports</span>
                  </NavLink>
                </li> */}
                {/* <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/blog"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ph:chart-pie-slice" className="menu-icon" />
                    <span>Blog</span>
                  </NavLink>
                </li> */}

                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/about"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="mdi:information-outline"
                      className="menu-icon"
                    />
                    <span>About Us</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/contact"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ic:outline-phone" className="menu-icon" />
                    <span>Contact Us</span>
                  </NavLink>
                </li>

                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "reschedule_cancellation",
                        "Reschedule Policy"
                      )
                    }
                  >
                    <Icon
                      icon="pepicons-pop:rewind-time"
                      className="menu-icon"
                    />
                    <span>Reschedule/Cancellation Policy</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "terms_and_conditions",
                        "Terms & Conditions"
                      )
                    }
                  >
                    <Icon
                      icon="material-symbols-light:conditions-rounded"
                      className="menu-icon"
                    />
                    <span>Terms & Conditions</span>
                  </NavLink>
                </li>

                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy("privacy_policy", "Privacy Policy")
                    }
                  >
                    <Icon icon="ph:detective" className="menu-icon" />
                    <span>Privacy Policy</span>
                  </NavLink>
                </li>
              </>
            ) : (
              <li style={{ margin: "2px" }}></li>
            )}

            {/* ///////////////////////// COUNSELOR ////////////////////////////////// */}

            {role === "counselor" ? (
              <>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/counselor-profile"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="gg:profile" className="menu-icon" />

                    <span> Profile</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  {/* {(interestedIn == "Essay Counseling" ||
                    interestedIn == "Essay + College Counseling") && (
                    <NavLink
                      to="/essay-counseling-slot"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon icon="guidance:time" className="menu-icon" />
                      <span>Manage Slots</span>
                    </NavLink>
                  )}
                  */}
                  <li style={{ margin: "2px" }}>
                    <NavLink
                      // to="/college-counseling-slot"
                      to="/essay-counseling-slot"
                      className={(navData) =>
                        navData.isActive ? "active-page" : ""
                      }
                    >
                      <Icon icon="guidance:time" className="menu-icon" />
                      <span>Manage Slots</span>
                    </NavLink>
                  </li>
                </li>
                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon icon="mdi-light:cart" className="menu-icon" />
                    <span>Manage Request</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/pending-bookings"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Pending Request
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/schedule-bookings"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Scheduled Slots
                      </NavLink>
                    </li>

                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/counselor-completed-bookings"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />{" "}
                        Completed Slots
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/reschedule-bookings"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />{" "}
                        Reschedule Request
                      </NavLink>
                    </li>
                  </ul>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/earning"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="hugeicons:money-04" className="menu-icon" />
                    <span>Earning</span>
                  </NavLink>
                </li>

                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "reschedule_cancellation",
                        "Reschedule Policy"
                      )
                    }
                  >
                    <Icon
                      icon="pepicons-pop:rewind-time"
                      className="menu-icon"
                    />
                    <span>Reschedule/Cancellation Policy</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "terms_and_conditions",
                        "Terms & Conditions"
                      )
                    }
                  >
                    <Icon
                      icon="material-symbols-light:conditions-rounded"
                      className="menu-icon"
                    />
                    <span>Terms & Conditions</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy("privacy_policy", "Privacy Policy")
                    }
                  >
                    <Icon icon="ph:detective" className="menu-icon" />
                    <span>Privacy Policy</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/about"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="mdi:information-outline"
                      className="menu-icon"
                    />
                    <span>About Us</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/contact"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ic:outline-phone" className="menu-icon" />
                    <span>Contact Us</span>
                  </NavLink>
                </li>
              </>
            ) : (
              <li style={{ margin: "2px" }}></li>
            )}

            {/* ///////////////////////// STUDENT ////////////////////////////////// */}

            {role === "student" ? (
              <>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/student-profile"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="gg:profile" className="menu-icon" />
                    <span>Profile </span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/approved-counselor-grid"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ph:user" className="menu-icon" />
                    <span>Counselor Testimonials</span>
                    {/* <span>Counselors </span> */}
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/student-package"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      // icon="mdi:credit-card-outline"
                      icon="material-symbols-light:package-outline"
                      className="menu-icon"
                    />

                    <span>Package Details</span>
                  </NavLink>
                </li>

                <li style={{ margin: "2px" }} className="dropdown">
                  <Link to="#">
                    <Icon
                      icon="flowbite:users-group-outline"
                      className="menu-icon"
                    />
                    <span>Manage Slots</span>
                  </Link>
                  <ul className="sidebar-submenu">
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        // to="/student-pending-booking-list"
                        to="/student-requested-slot-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-success-main w-auto" />
                        <span> Pay & Book</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/student-scheduled-booking-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                        <span> Scheduled </span>
                      </NavLink>
                    </li>

                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/student-completed-booking-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-primary-600 w-auto" />
                        <span> Completed</span>
                      </NavLink>
                    </li>
                    <li style={{ margin: "2px" }}>
                      <NavLink
                        to="/student-rescheduled-booking-list"
                        className={(navData) =>
                          navData.isActive ? "active-page" : ""
                        }
                      >
                        <i className="ri-circle-fill circle-icon text-warning-main w-auto" />
                        <span> Reschedule Request</span>
                      </NavLink>
                    </li>
                  </ul>
                </li>

                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="/student-invoice-list"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="mdi:credit-card-outline"
                      className="menu-icon"
                    />

                    <span>Invoice </span>
                  </NavLink>
                </li>

                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "reschedule_cancellation",
                        "Reschedule Policy"
                      )
                    }
                  >
                    <Icon
                      icon="pepicons-pop:rewind-time"
                      className="menu-icon"
                    />
                    <span>Reschedule/Cancellation Policy</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy(
                        "terms_and_conditions",
                        "Terms & Conditions"
                      )
                    }
                  >
                    <Icon
                      icon="material-symbols-light:conditions-rounded"
                      className="menu-icon"
                    />
                    <span>Terms & Conditions</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    onClick={() =>
                      handleOpenPolicy("privacy_policy", "Privacy Policy")
                    }
                  >
                    <Icon icon="ph:detective" className="menu-icon" />
                    <span>Privacy Policy</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/about"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon
                      icon="mdi:information-outline"
                      className="menu-icon"
                    />
                    <span>About Us</span>
                  </NavLink>
                </li>
                <li style={{ margin: "2px" }}>
                  <NavLink
                    to="https://dreamdor.com/contact"
                    target="_blank"
                    className={(navData) =>
                      navData.isActive ? "active-page" : ""
                    }
                  >
                    <Icon icon="ic:outline-phone" className="menu-icon" />
                    <span>Contact Us</span>
                  </NavLink>
                </li>
              </>
            ) : (
              <li style={{ margin: "2px" }}></li>
            )}
          </ul>
        </div>
      </aside>

      <main
        className={sidebarActive ? "dashboard-main active" : "dashboard-main"}
      >
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button
                  type="button"
                  className="sidebar-toggle"
                  onClick={sidebarControl}
                >
                  {sidebarActive ? (
                    <Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />
                  ) : (
                    <Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />
                  )}
                </button>
                <button
                  onClick={mobileMenuControl}
                  type="button"
                  className="sidebar-mobile-toggle"
                >
                  <Icon icon="heroicons:bars-3-solid" className="icon" />
                </button>
              </div>
            </div>

            {role === "student" && (
              <div className="col-auto">
                <div className="d-flex flex-wrap align-items-center gap-4">
                  {/* <Card >
                    <CardContent> */}
                  <DreamdorBanner />
                  {/* </CardContent>
                  </Card> */}
                </div>
              </div>
            )}

            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {role == "counselor" && (
                  <>
                    <span
                      className=" redBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-danger-600 bg-transparent px-20 py-9 radius-9"
                      onClick={() => {
                        window.open(
                          `${baseUrl}/public/uploads/howItWork/c_brochure.pdf`,
                          "_blank"
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      How it works
                      {/* <HowItWorksButton /> */}
                    </span>
                    <span
                      className="greenBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-success-600 bg-transparent px-20 py-9 radius-9"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   setOpen(true);
                      //   HelpandSupportApi("counselor");
                      // }}
                      onClick={counselorHelpAndSupport}
                    >
                      Help & Support
                    </span>
                  </>
                )}
                {role == "counselor" && (
                  <>
                    {status == 0 && (
                      <span className="redBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-danger-600 bg-transparent px-20 py-9 radius-9">
                        Rejected
                      </span>
                    )}
                    {(status == 1 || status == 3) && (
                      <span className="greenBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-success-600 bg-transparent px-20 py-9 radius-9">
                        Approved
                      </span>
                    )}
                    {status == 2 && (
                      <span className="yellowBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-warning-600 bg-transparent px-20 py-9 radius-9">
                        Pending
                      </span>
                    )}
                  </>
                )}
                {role == "student" && (
                  <>
                    <span
                      className=" redBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-danger-600 bg-transparent px-20 py-9 radius-9"
                      onClick={() => {
                        window.open(
                          `${baseUrl}/public/uploads/howItWork/s_brochure.pdf`,
                          "_blank"
                        );
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      How it works
                      {/* <HowItWorksButton /> */}
                    </span>

                    <span
                      className="greenBorder badge text-sm fw-semibold border rounded-pill border-default-600 text-success-600 bg-transparent px-20 py-9 radius-9"
                      style={{ cursor: "pointer" }}
                      // onClick={() => {
                      //   setOpen(true);
                      //   HelpandSupportApi("student");
                      // }}
                      onClick={helpAndSupport}
                    >
                      Help & Support
                    </span>
                  </>
                )}

                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    {profileImage ? (
                      <img
                        src={profileImage}
                        alt="image_user"
                        className="w-40-px h-40-px object-fit-cover rounded-circle"
                      />
                    ) : (
                      <Avatar
                        src={""}
                        alt={name}
                        sx={{
                          width: 40,
                          height: 40,
                          margin: "0 auto",
                          border: "3px solid white",
                          boxShadow: 1,
                          bgcolor: "#124178",
                          fontSize: 18,
                        }}
                      >
                        {name?.toUpperCase().charAt[0]}
                      </Avatar>
                    )}
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-primary-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-primary-light fw-semibold mb-2">
                          {role == "admin" && name} {role == "student" && name}{" "}
                          {role == "counselor" && name}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">
                          {role == "admin" && email}{" "}
                          {role == "student" && email}{" "}
                          {role == "counselor" && email}
                        </span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon
                          icon="radix-icons:cross-1"
                          className="icon text-xl"
                        />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      {role === "counselor" ? (
                        <li style={{ margin: "2px" }}>
                          <Link
                            className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                            to="/reset-password"
                          >
                            <Icon
                              icon="icon-park-outline:setting-two"
                              className="icon text-xl"
                            />
                            Reset Password
                          </Link>
                        </li>
                      ) : (
                        <li style={{ margin: "2px" }}></li>
                      )}

                      {role === "student" ? (
                        <li style={{ margin: "2px" }}>
                          <Link
                            className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                            // to="/counselor-profile"
                            to="/student-profile"
                          >
                            <Icon
                              icon="solar:user-linear"
                              className="icon text-xl"
                            />
                            Profile
                          </Link>
                        </li>
                      ) : (
                        <li style={{ margin: "2px" }}></li>
                      )}
                      {role === "student" ? (
                        <li style={{ margin: "2px" }}>
                          <Link
                            className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-primary d-flex align-items-center gap-3"
                            to="/student-reset-password"
                          >
                            <Icon
                              icon="icon-park-outline:setting-two"
                              className="icon text-xl"
                            />
                            Reset Password
                          </Link>
                        </li>
                      ) : (
                        <li style={{ margin: "2px" }}></li>
                      )}

                      <li style={{ margin: "2px" }}>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          to="#"
                          onClick={callLogoutAPI}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" />{" "}
                          Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}
              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        <div>
          <HelpSupportModal open={open} handleClose={() => setOpen(false)} />

          <Modal
            open={showModal}
            onClose={() => setShowModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <IconButton
                onClick={() => setShowModal(false)}
                sx={{ position: "absolute", top: 8, right: 8 }}
                aria-label="close"
              >
                <CloseIcon />
              </IconButton>

              <Typography variant="h6" mb={2}>
                {modalTitle}
              </Typography>

              {policyLoading ? (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "200px",
                  }}
                >
                  <CircularProgress />
                </Box>
              ) : (
                <Box dangerouslySetInnerHTML={{ __html: selectedPolicy }} />
              )}
            </Box>
          </Modal>
        </div>
      </main>
    </section>
  );
};

export default MasterLayout;
